var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.8291 27.0042L19.3096 18.4846C21.0791 16.5199 22.1667 13.9294 22.1667 11.0833C22.1666 4.97202 17.1947 0 11.0834 0C4.97202 0 0 4.97202 0 11.0834C0 17.1947 4.97202 22.1667 11.0834 22.1667C13.9295 22.1667 16.5199 21.0791 18.4847 19.3096L27.0042 27.8291C27.1182 27.943 27.2675 28 27.4167 28C27.5659 28 27.7152 27.943 27.8292 27.8291C28.057 27.6012 28.057 27.2321 27.8291 27.0042ZM11.0834 21C5.61575 21 1.1667 16.5515 1.1667 11.0834C1.1667 5.6152 5.61575 1.16665 11.0834 1.16665C16.551 1.16665 21 5.61515 21 11.0834C21 16.5516 16.551 21 11.0834 21Z","fill":"white"}));
}

SearchIconInline.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
